import React, { useState } from "react";
import classes from "../Profile/General.module.css";
import GenerateKey from "../../components/AdminSettings/GenerateKey";
import PopupWrapper from "../../components/PopupWrapper";
import AdminPortal from "../../components/AdminSettings/AdminPortal";

function AdminSettings() {
  //   const [adminSettings, setAdminSettings] = useState();
  const [adminPortal, setAdminPortal] = useState();

  return (
    <div >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <div>
            <ul className={classes.unorderedList}>
              <li>Admin Portal</li>
              <li>
                <span className={classes.spanMargin}>\</span>
              </li>
              <li className={classes.breadcrumbColor}>Manage Keys</li>
            </ul>
          </div>
          <AdminPortal />
          <button
            className="btn btn-primary text-white btn-outline py-3 px-4"
            onClick={() => {
              setAdminPortal(true);
            }}
          >
            Add Account
          </button>
          <PopupWrapper
            Component={
              <GenerateKey
                Close={() => {
                  setAdminPortal(false);
                }}
              />
            }
            toShow={adminPortal}
            closeEventHandler={() => {
              setAdminPortal(false);
            }}
          />
        </div>
      </section>
    </div>
  );
}

export default AdminSettings;
